const { imgParse } = require('../../../lib');
module.exports = function(url, baseUrl) {
  return imgParse(url, baseUrl)
}
